import { CdHeading, CdText } from '../../atoms/CdTypography';
import { cx } from '../../utils';
import styles from './CdStepItem.module.scss';

export interface CdStepItemProps {
  /** Displayed number, e.g. 1 → "01". */
  step: number;
  title: string;
  description: string;
  className?: string;
}

/** Numbered step used in "How it works" / "New to PermiOne". */
export const CdStepItem = ({ step, title, description, className }: CdStepItemProps) => {
  return (
    <div className={cx(styles.root, className)}>
      <span className={styles.number} aria-hidden="true">
        {String(step).padStart(2, '0')}
      </span>
      <div className={styles.body}>
        <CdHeading level={3} size="md">
          <span className={styles.srStep}>Step {step}: </span>
          {title}
        </CdHeading>
        <CdText tone="secondary">{description}</CdText>
      </div>
    </div>
  );
};
